// Indonesian banks + common e-wallets, grouped for a native <select>.
// Used for per-person payment details on the summary/share/receipt.
export const BANK_GROUPS = [
  {
    label: "Popular",
    banks: [
      "BCA",
      "Bank Mandiri",
      "BRI",
      "BNI",
      "CIMB Niaga",
      "BTN",
      "Bank Danamon",
      "Permata Bank",
      "Bank Syariah Indonesia (BSI)",
    ],
  },
  {
    label: "Digital & E-wallet",
    banks: [
      "GoPay",
      "OVO",
      "DANA",
      "ShopeePay",
      "LinkAja",
      "Jenius (BTPN)",
      "blu by BCA Digital",
      "Bank Jago",
      "SeaBank",
      "Allo Bank",
      "Bank Neo Commerce",
      "Bank Raya",
      "Superbank",
      "Krom Bank",
    ],
  },
  {
    label: "Banks",
    banks: [
      "Bank Aladin Syariah",
      "Bank ANZ Indonesia",
      "Bank Artha Graha",
      "Bank BJB",
      "Bank BJB Syariah",
      "Bank BNP Paribas",
      "Bank Bumi Arta",
      "Bank Capital Indonesia",
      "Bank Commonwealth",
      "Bank DBS Indonesia",
      "Bank DKI",
      "Bank Ganesha",
      "Bank HSBC Indonesia",
      "Bank IBK Indonesia",
      "Bank ICBC Indonesia",
      "Bank Ina Perdana",
      "Bank Index Selindo",
      "Bank J Trust Indonesia",
      "Bank KB Bukopin",
      "Bank Mandiri Taspen",
      "Bank Maspion",
      "Bank Mayapada",
      "Bank Maybank Indonesia",
      "Bank Mega",
      "Bank Mega Syariah",
      "Bank Mestika Dharma",
      "Bank MNC Internasional",
      "Bank Muamalat",
      "Bank Nagari (BPD Sumbar)",
      "Bank Nationalnobu",
      "Bank OCBC NISP",
      "Bank of America",
      "Bank of China",
      "Bank Panin",
      "Bank Panin Dubai Syariah",
      "Bank QNB Indonesia",
      "Bank Sahabat Sampoerna",
      "Bank SBI Indonesia",
      "Bank Shinhan Indonesia",
      "Bank Sinarmas",
      "Bank Victoria International",
      "Bank Woori Saudara",
      "Citibank",
      "Standard Chartered Bank",
      "BPD Aceh",
      "BPD Bali",
      "BPD Bengkulu",
      "BPD DIY",
      "BPD Jambi",
      "BPD Jateng (Bank Jateng)",
      "BPD Jatim (Bank Jatim)",
      "BPD Kalbar (Bank Kalbar)",
      "BPD Kalsel (Bank Kalsel)",
      "BPD Kalteng (Bank Kalteng)",
      "BPD Kaltimtara",
      "BPD Lampung",
      "BPD Maluku Malut",
      "BPD NTB Syariah",
      "BPD NTT",
      "BPD Papua",
      "BPD Riau Kepri",
      "BPD Sulselbar",
      "BPD Sulteng",
      "BPD Sultra",
      "BPD Sulutgo",
      "BPD Sumsel Babel",
      "BPD Sumut",
    ],
  },
];

export const ALL_BANKS = BANK_GROUPS.flatMap((g) => g.banks);
